import axios from "axios";

export const read = async (skip,query,searchThis) => {
    try{
        console.log(searchThis)
        return axios.get(`${process.env.REACT_APP_BACKEND_URL}/listKlien?skip=${skip}&query=${query}&property=${searchThis}`,{
        })
    } catch(error){
        throw new Error(error);
    }
}